import React from 'react';
import { RadioGroup } from '@uhg-abyss/web/ui/RadioGroup';

export const CommunicationPreference = () => {
  return (
    <React.Fragment>
      <RadioGroup
        label="Preferred mode of contact"
        model="attestation.commPreference"
        aria-labelledby="radio-provider"
        validators={{
          required: (value) => {
            return !value;
          },
        }}
        defaultValue="Phone"
        required
        display="row"
      >
        <RadioGroup.Radio
          id="radio-comm-pref-email"
          value="Phone"
          label="Phone"
        >
          Phone
        </RadioGroup.Radio>
        <RadioGroup.Radio
          id="radio-comm-pref-phone"
          value="Email"
          label="Email"
        >
          Email
        </RadioGroup.Radio>
      </RadioGroup>
    </React.Fragment>
  );
};

CommunicationPreference.propTypes = {};

CommunicationPreference.defaultProps = {};
